import React from 'react';
import PrimaryButton from '../../button/PrimaryButton';
import SecondaryButton from '../../button/SecondaryButton';
import GuaranteeItem from '../../homepage/GuaranteeItem/GuaranteeItem';
import './CTASection.css';

/**
 * CTASection Component
 * Call-to-action section with title, subtitle, buttons, and guarantees
 * 
 * @param {string} title - CTA title (can contain JSX)
 * @param {string} highlight - Highlight text (displayed separately)
 * @param {string} subtitle - CTA subtitle
 * @param {object} primaryButton - Primary button config {text, onClick}
 * @param {object} secondaryButton - Secondary button config {text, onClick}
 * @param {Array} guarantees - Array of guarantee strings or objects {text, icon}
 * @param {boolean} showBackgroundAnimation - Whether to show floating background elements
 * @param {string} className - Additional CSS classes
 */
const CTASection = ({
  title,
  highlight,
  subtitle,
  primaryButton,
  secondaryButton,
  guarantees = [],
  showBackgroundAnimation = true,
  className = ''
}) => {
  return (
    <section className={`cta-section ${className}`}>
      <div className="cta-container">
        {showBackgroundAnimation && (
          <div className="cta-background-animation">
            <div className="floating-element element-1"></div>
            <div className="floating-element element-2"></div>
            <div className="floating-element element-3"></div>
          </div>
        )}
        
        <div className="cta-content">
          <h2 className="cta-title">
            {title}
            {highlight && (
              <span className="cta-highlight">{highlight}</span>
            )}
          </h2>
          {subtitle && (
            <p className="cta-subtitle">{subtitle}</p>
          )}
          
          {(primaryButton || secondaryButton) && (
            <div className="cta-actions">
              {primaryButton && (
                <PrimaryButton
                  onClick={primaryButton.onClick}
                  size="large"
                  className="cta-primary"
                >
                  {primaryButton.text}
                </PrimaryButton>
              )}
              {secondaryButton && (
                <SecondaryButton
                  onClick={secondaryButton.onClick}
                  size="large"
                  variant="outline"
                  className="cta-secondary"
                >
                  {secondaryButton.text}
                </SecondaryButton>
              )}
            </div>
          )}
          
          {guarantees.length > 0 && (
            <div className="cta-guarantees">
              {guarantees.map((guarantee, index) => {
                const guaranteeText = typeof guarantee === 'string' ? guarantee : guarantee.text;
                const guaranteeIcon = typeof guarantee === 'object' && guarantee.icon ? guarantee.icon : '✓';
                return (
                  <GuaranteeItem
                    key={index}
                    text={guaranteeText}
                    icon={guaranteeIcon}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;


